import { InputErrorMessage as Error, Text } from '@/components';
import APP_CONFIG from '@/config/app';
import { ErrorMessage } from '@hookform/error-message';
import { AnimatePresence } from 'framer-motion';
import { FC, useMemo } from 'react';
import { FieldErrors, UseFormClearErrors } from 'react-hook-form';
const { MAIN_BACKDROP_BLUR } = APP_CONFIG.STYLES;
interface RatingInputProps {
  value: number;
  onChange: (value: number) => void;
  name: string;
  errors: FieldErrors;
  clearErrors?: UseFormClearErrors<any>;
  showError?: boolean;
  className?: string;
  label?: string;
}
const RatingInput: FC<RatingInputProps> = ({
  value,
  onChange,
  name,
  errors,
  clearErrors,
  showError,
  className = '',
  label,
}) => {
  const handleBoxClick = (index: number) => {
    if (index === 0 && value === 1) {
      onChange(0);
    } else {
      onChange(index + 1);
    }
  };
  const ratingBoxes = useMemo(() => {
    return Array.from({ length: 5 }, (_, index) => index < value);
  }, [value]);
  const errorMessage = errors[name];
  const hasError = !!(errors && errorMessage);
  const handleOnBlur = () => {
    if (hasError && clearErrors) {
      clearErrors(name);
    }
  };
  const getRoundedClass = (index: number, count: number) => {
    if (index === 0) return 'rounded-l-2xs';
    if (index === count - 1) return 'rounded-r-2xs';
    return '';
  };
  return (
    <div className={`flex flex-col gap-2 w-full ${className}`}>
      {label && <Text value={label} color={'secondary'} />} {}
      <div
        className={
          hasError ? 'bg-error/15 flex gap-0.5 rounded-t-2xs' : 'flex gap-0.5'
        }
      >
        {Array.from({ length: 5 }).map((_, index) => (
          <div
            key={index}
            className={`w-8 h-8 flex-1 flex items-center justify-center text-center ${getRoundedClass(
              index,
              5,
            )} cursor-pointer ${
              index < value
                ? 'bg-accent bg-opacity-100'
                : 'bg-accent bg-opacity-5'
            }`}
            onClick={() => handleBoxClick(index)}
            onBlur={handleOnBlur}
            tabIndex={0}
          >
            {APP_CONFIG.RATING_EMOJIS[index]}
          </div>
        ))}
      </div>
      <ErrorMessage
        errors={errors}
        name={name as any}
        render={({ message }) =>
          message && showError ? (
            <AnimatePresence>
              <Error
                message={message}
                className={`relative bottom-0.5 left-0 right-0 backdrop-blur${MAIN_BACKDROP_BLUR}`}
              />
            </AnimatePresence>
          ) : null
        }
      />
    </div>
  );
};
export default RatingInput;
